import React from 'react';
import { IconProps } from '../types/types';

const VPSAI: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#000"/><path d="m14.93 11.015-4.965 2.92L5 11.016v1.377l4.965 2.92 4.965-2.92v-1.377Z" fill="#269CA5"/><path d="m14.93 8.97-4.965 2.921L5 8.971v1.377l4.965 2.92 4.965-2.92V8.97Z" fill="#2DD48E"/><path fillRule="evenodd" clipRule="evenodd" d="m5 8.262 4.965 2.92 4.965-2.92v-.668L9.965 4.687 5 7.595v.668Zm1.785-.327 3.18 1.87 3.18-1.87-3.18-1.87-3.18 1.87Z" fill="#64DFAC"/><path d="m9.088 8.637.877-.521.876.521 1.189-.688-2.065-1.21-2.066 1.21 1.19.688Z" fill="#fff"/></svg>
);

export default VPSAI;
